<template>
  <b-modal
    id="cropUploadModal"
    v-model="state"
    :title="title"
    size="lg"
    :ok-title="$t('eMedia_crop_ok')"
    :ok-disabled="!isCropperReady"
    :no-close-on-backdrop="true"
    @hide="onClose"
    @ok.prevent="onOk"
  >
    <div class="d-flex flex-row">
      <div class="w-50">
        <img
          v-if="state"
          ref="cropperRef"
          :src="src"
          style="display: block; max-width: 100%;"
          @load="onImgLoad"
        >
      </div>
      <div class="w-50 d-flex flex-column align-items-center justify-content-center">
        <font-awesome-icon
          v-if="!isCropperReady"
          icon="spinner"
          :spin="true"
          size="4x"
        />
        <div class="crop-upload-preview preview-portrait" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import Cropper from 'cropperjs'

export default {
  name: 'ModalCropUpload',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: 'image.jpg'
    },
    // Default 2:3 portrait, identical to the frontend gallery cropper (aspectRatio 0.666)
    aspectRatio: {
      type: Number,
      default: 2 / 3
    },
    title: {
      type: String,
      default: 'Crop image'
    }
  },
  data () {
    return {
      state: this.value,
      isCropperReady: false,
      cropper: undefined
    }
  },
  watch: {
    value (n) {
      this.state = n
    }
  },
  methods: {
    onImgLoad () {
      const img = this.$refs.cropperRef
      this.cropper = new Cropper(img, {
        aspectRatio: this.aspectRatio,
        viewMode: 1,
        autoCropArea: 1,
        guides: false,
        preview: '.crop-upload-preview',
        checkOrientation: true,
        ready: () => {
          this.isCropperReady = true
        }
      })
    },
    onClose () {
      this.isCropperReady = false
      if (this.cropper) {
        this.cropper.destroy()
        this.cropper = undefined
      }
      this.state = false
      this.$emit('input', false)
    },
    onOk () {
      if (!this.isCropperReady) {
        return
      }
      this.isCropperReady = false
      this.cropper.getCroppedCanvas({
        maxWidth: 2000,
        maxHeight: 3000,
        imageSmoothingQuality: 'high'
      }).toBlob((blob) => {
        const name = this.fileName.replace(/\.[^/.]+$/, '') + '.jpg'
        const file = new File([blob], name, { type: 'image/jpeg' })
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = undefined
        }
        this.$emit('on-cropped', file)
        this.state = false
        this.$emit('input', false)
      }, 'image/jpeg', 0.92)
    }
  }
}
</script>

<style scoped>
  .crop-upload-preview {
    overflow: hidden;
  }
  .crop-upload-preview > img {
    max-width: 100%;
  }
  .preview-portrait {
    width: 12rem;
    height: 18rem;
  }
</style>
